/* eslint-disable react-hooks/set-state-in-effect */
import { useEffect, useMemo, useState } from 'react';

import { Hcp } from '@/core/graphql/generated/types';
import { isOfTypeHcp } from '@/utils/hcp/isOfTypeHcp';
import { useHcpUrlParams } from '@/utils/hcp/useHcpUrlParams';

import {
	GetHcpByIdQuery,
	useGetHcpByIdLazyQuery
} from '../_graphql/query/GetHCPById.hook';

const DEFAULT_AFFILIATIONS_PAGE_SIZE = 20;

export const useHcpData = (
	suppressErrors: boolean = false,
	affiliationsPageSize: number = DEFAULT_AFFILIATIONS_PAGE_SIZE,
	enabled: boolean = true
) => {
	const { id } = useHcpUrlParams(suppressErrors);
	const [getHcpById, { data, loading: queryLoading }] =
		useGetHcpByIdLazyQuery();
	const [sessionData, setSessionData] = useState<GetHcpByIdQuery | undefined>();

	useEffect(() => {
		if (id && enabled) {
			setSessionData(undefined);
			getHcpById({
				// Note(Filip): Having any caching of HCP data helps us to parse the data in Apollo Client as soon as it arrives from the source
				fetchPolicy: 'cache-and-network',
				variables: {
					vid: id,
					affiliationsPageSize
				}
			});
		} else if (!enabled) {
			setSessionData(undefined);
		}
	}, [getHcpById, id, affiliationsPageSize, enabled]);

	useEffect(() => {
		if (enabled && data) setSessionData(data);
	}, [enabled, data]);

	const loading = enabled && (queryLoading || (!!id && !sessionData));

	const hcp = useMemo(() => {
		return sessionData?.hcp;
	}, [sessionData]);

	if (
		!loading &&
		hcp &&
		'__typename' in hcp &&
		hcp.__typename === 'ResourceNotFound'
	) {
		return {
			hcp: null,
			loading,
			isInvalidHcp: true
		};
	}

	return {
		hcp: isOfTypeHcp(hcp) ? (hcp as Hcp) : null,
		loading,
		isInvalidHcp: false
	};
};
